import { useQuery } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { budgetApi } from 'src/Services/API';

/**
 * Read-only reconciliation of the budget against the real operations of the calendar year.
 * The budget never writes an expense: this is the single, one-way bridge between the two.
 */
const useBudgetTracking = (year: number, enabled = true) => {
  const assetId = useCurrentAssetId();

  return useQuery({
    queryKey: ['budget', assetId, year, 'tracking'],
    queryFn: async () => {
      if (!assetId) throw new Error('No assetId provided');
      return (await budgetApi.budgetControllerGetTracking(assetId, year)).data;
    },
    enabled: !!assetId && enabled,
  });
};

export default useBudgetTracking;
